import type { DatePickerDesignTokens, DatePickerTokenSections } from '@primeuix/themes/types/datepicker';

export const root: DatePickerTokenSections.Root = {
    transitionDuration: '{transition.Duration}'
};

export const panel: DatePickerTokenSections.Panel = {
    background: '{content.background}',
    borderColor: '{content.borderColor}',
    color: '{content.color}',
    borderRadius: '{content.borderRadius}',
    shadow: '{overlay.popover.shadow}',
    padding: '{overlay.popover.padding}'
};

export const header: DatePickerTokenSections.Header = {
    background: '{content.background}',
    borderColor: '{content.borderColor}',
    color: '{content.color}',
    padding: '0 0 0.5rem 0'
};

export const title: DatePickerTokenSections.Title = {
    gap: '0.5rem',
    fontWeight: '500'
};

export const dropdown: DatePickerTokenSections.Dropdown = {
    width: '2.5rem',
    sm: {
        width: '2rem'
    },
    lg: {
        width: '3rem'
    },
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hoverBorderColor}',
    activeBorderColor: '{formField.activeBorderColor}',
    borderRadius: '{formField.borderRadius}',
    focusRing: {
        width: '{formField.focusRing.width}',
        style: '{formField.focusRing.style}',
        color: '{formField.focusRing.color}',
        offset: '{formField.focusRing.offset}',
        shadow: '{formField.focusRing.shadow}'
    }
};

export const inputIcon: DatePickerTokenSections.InputIcon = {
    color: '{formField.iconColor}'
};

export const selectMonth: DatePickerTokenSections.SelectMonth = {
    hoverBackground: '{content.hoverBackground}',
    color: '{content.color}',
    hoverColor: '{content.hoverColor}',
    padding: '0.25rem 0.5rem',
    borderRadius: '{content.borderRadius}'
};

export const selectYear: DatePickerTokenSections.SelectYear = {
    hoverBackground: '{content.hoverBackground}',
    color: '{content.color}',
    hoverColor: '{content.hoverColor}',
    padding: '0.25rem 0.5rem',
    borderRadius: '{content.borderRadius}'
};

export const group: DatePickerTokenSections.Group = {
    borderColor: '{content.borderColor}',
    gap: '{overlay.popover.padding}'
};

export const dayView: DatePickerTokenSections.DayView = {
    margin: '0.5rem 0 0 0'
};

export const weekDay: DatePickerTokenSections.WeekDay = {
    padding: '0.25rem',
    fontWeight: '500',
    color: '{content.color}'
};

export const date: DatePickerTokenSections.Date = {
    hoverBackground: '{content.hoverBackground}',
    selectedBackground: '{primary.color}',
    rangeSelectedBackground: '{highlight.background}',
    color: '{content.color}',
    hoverColor: '{content.hoverColor}',
    selectedColor: '{primary.contrast.color}',
    rangeSelectedColor: '{highlight.color}',
    width: '2rem',
    height: '2rem',
    borderRadius: '{extend.borderRadius.rounded}',
    padding: '0.25rem',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    }
};

export const monthView: DatePickerTokenSections.MonthView = {
    margin: '0.5rem 0 0 0'
};

export const month: DatePickerTokenSections.Month = {
    padding: '0.375rem',
    borderRadius: '{content.borderRadius}'
};

export const yearView: DatePickerTokenSections.YearView = {
    margin: '0.5rem 0 0 0'
};

export const year: DatePickerTokenSections.Year = {
    padding: '0.375rem',
    borderRadius: '{content.borderRadius}'
};

export const buttonbar: DatePickerTokenSections.Buttonbar = {
    padding: '0.5rem 0 0 0',
    borderColor: '{content.borderColor}'
};

export const timePicker: DatePickerTokenSections.TimePicker = {
    padding: '0.5rem 0 0 0',
    borderColor: '{content.borderColor}',
    gap: '0.5rem',
    buttonGap: '0.25rem'
};

export const colorScheme: DatePickerTokenSections.ColorScheme = {
    light: {
        dropdown: {
            background: '{surface.100}',
            hoverBackground: '{surface.200}',
            activeBackground: '{surface.300}',
            color: '{surface.600}',
            hoverColor: '{surface.700}',
            activeColor: '{surface.800}'
        },
        today: {
            background: '{surface.200}',
            color: '{surface.900}'
        }
    },
    dark: {
        dropdown: {
            background: '{surface.800}',
            hoverBackground: '{surface.700}',
            activeBackground: '{surface.600}',
            color: '{surface.300}',
            hoverColor: '{surface.200}',
            activeColor: '{surface.100}'
        },
        today: {
            background: '{surface.700}',
            color: '{surface.0}'
        }
    }
};

export default {
    root,
    panel,
    header,
    title,
    dropdown,
    inputIcon,
    selectMonth,
    selectYear,
    group,
    dayView,
    weekDay,
    date,
    monthView,
    month,
    yearView,
    year,
    buttonbar,
    timePicker,
    colorScheme
} satisfies DatePickerDesignTokens;